import SidebarFilter from "./sidebar-filter/SidebarFilter.jsx"
import Panel from "./panel/Panel.jsx"
import CollapsiblePanel from "./panel/CollapsiblePanel.jsx"
import SelectList from "./select-list/SelectList.jsx"
import CheckboxList from "./checkbox-list/CheckboxList.jsx"

export default {
  SidebarFilter,
  Panel,
  CollapsiblePanel,
  SelectList,
  CheckboxList,
}
